// Shared "Set as Default" enabled/tooltip logic for a template, used by the
// list row, the mobile card, and the editor so the copy stays consistent.
//
// Only the current default is disabled — any other template (including the
// System Built-in when it isn't currently the default) can be promoted.
export const getSetDefaultState = (template) => {
  const disabled = !template || template.is_default;
  const title = template?.is_default
    ? "This template is already your default."
    : "Set as default template";
  return { disabled, title };
};
